import { useQuery } from '@apollo/client/react';
import { type CompletePreBookingFragment, GetStorePreBookingsDocument } from '@drycut/graphql';
import { Stack } from '@drycut/ui-components';
import { formatDateTime } from '@drycut/ui-format-utils';

import { PageLoading } from '../../PageLoading';
import EmptyState from '../EmptyState';
import QueueTable from '../QueueTable';
import { ConvertPreBookingButton } from './ConvertBookingButton';

export function PreBookingsTable(): React.ReactElement {
  // Get the the data from the server the first time and then use the cache if present.
  const { data, loading } = useQuery(GetStorePreBookingsDocument, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  });

  const nodes = data?.storePreBookings?.nodes || [];
  const preBookings = nodes.filter((node): node is CompletePreBookingFragment => Boolean(node));

  if (loading) return <PageLoading />;

  if (preBookings.length === 0) {
    return <EmptyState>Keine Buchungen vorhanden.</EmptyState>;
  }

  return (
    <QueueTable.Table>
      <QueueTable.TableHeader>
        <QueueTable.THead className="w-28">Code</QueueTable.THead>
        <QueueTable.THead className="w-28">Kunde</QueueTable.THead>
        <QueueTable.THead>Erwartete Zeit</QueueTable.THead>
        <QueueTable.THead />
      </QueueTable.TableHeader>

      <tbody>
        {preBookings.map((preBooking) => (
          <tr
            key={preBooking?.id}
            className="antialiased text-left font-aribau bg-zinc-100 text-xs"
          >
            <QueueTable.TableCell className="text-[0.65rem] text-zinc-500">
              {preBooking?.uid.split('-')[0].toUpperCase()}
            </QueueTable.TableCell>

            <QueueTable.TableCell className="font-aribaubold text-zinc-700">
              {preBooking?.customer.name}
            </QueueTable.TableCell>
            <QueueTable.TableCell>
              {formatDateTime(preBooking?.bookTime, {
                day: 'numeric',
                month: 'short',
                hour: 'numeric',
                minute: 'numeric',
              })}
            </QueueTable.TableCell>
            <QueueTable.TableCell>
              <Stack direction="row" className="justify-end items-center">
                <ConvertPreBookingButton preBooking={preBooking} />
              </Stack>
            </QueueTable.TableCell>
          </tr>
        ))}
      </tbody>
    </QueueTable.Table>
  );
}
